import { render, staticRenderFns } from "./FailedPassword.vue?vue&type=template&id=7af63096&"
import script from "./FailedPassword.vue?vue&type=script&lang=js&"
export * from "./FailedPassword.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports